import { Action, Module } from 'vuex-module-decorators';
import ImpactBoardMembersApi from '@/api/impact-board-members.api';
import { take } from 'rxjs/operators';
import { ImpactBoardMemberModel } from '@/models/impact-board-member.model';
import store from '@/store';
import { EntityStateAdapter } from '@/store/base.store';

export const featureKey = 'impact_board';

// @ts-ignore
if (store.state.impact_board) {
    store.unregisterModule(featureKey)
}

@Module({
    store,
    dynamic: true,
    name: featureKey,
    namespaced: true,
})
export class ImpactBoardMembersStoreModule extends EntityStateAdapter<ImpactBoardMemberModel> {
    @Action({ commit: 'insertMany', rawError: true })
    fetchMembers(): Promise<ImpactBoardMemberModel[]> {
        this.updateLoading(true);
        return (new ImpactBoardMembersApi())
            .getAllMembers()
            .pipe(take(1))
            .toPromise()
    }

    get allMembers(): ImpactBoardMemberModel[] {
        return this._entities
    }

    get memberById(): (id: number) => ImpactBoardMemberModel | undefined {
        return (id: number) => this._entities.find((v) => v.id === id);
    }

    get loading(): boolean {
        return this._loading;
      }
}
